import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71b2f7da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "raraya_name_isSelect" }
const _hoisted_2 = {
  class: "cf",
  style: {"height":"38px"}
}
const _hoisted_3 = { class: "button_no" }
const _hoisted_4 = { class: "button_yes" }
const _hoisted_5 = { class: "raraya_name_block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NameColorForm = _resolveComponent("NameColorForm")!
  const _component_NameCharForm = _resolveComponent("NameCharForm")!
  const _component_FormTab = _resolveComponent("FormTab")!

  return (_openBlock(), _createBlock(_component_FormTab, {
    class: "name-content",
    index: _ctx.index
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onNoClick && _ctx.onNoClick(...args))),
              class: _normalizeClass({ selected: _ctx.configNonameId == _ctx.nameSettings.noName.id }),
              id: "raraya_name_no"
            }, "× 入れない", 2)
          ]),
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onYesClick && _ctx.onYesClick(...args))),
              class: _normalizeClass({ selected: _ctx.configNonameId == _ctx.nameSettings.yesName.id }),
              id: "raraya_name_yes"
            }, "○ 入れる", 2)
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createVNode(_component_NameColorForm),
        _createVNode(_component_NameCharForm)
      ], 512), [
        [_vShow, _ctx.configNonameId == _ctx.nameSettings.yesName.id]
      ])
    ]),
    _: 1
  }, 8, ["index"]))
}